import { render, staticRenderFns } from "./created-mail.vue?vue&type=template&id=c1597648&scoped=true"
import script from "./created-mail.vue?vue&type=script&lang=js"
export * from "./created-mail.vue?vue&type=script&lang=js"
import style0 from "./created-mail.vue?vue&type=style&index=0&id=c1597648&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1597648",
  null
  
)

export default component.exports